import React from "react";
import { Btn } from "../../../AbstractElements";
import CustomInput from "../../../Component/BasicComponents/CustomInput";

type Props = {};

interface PlaylistTypeModalContentProps {
  handleSubmit: (e: React.FormEvent) => void;
  leaveType: string;
  setLeaveType: React.Dispatch<React.SetStateAction<string>>;
  shortCode: string;
  setShortCode: React.Dispatch<React.SetStateAction<string>>;
  handleClose: () => void;
  updateForm: string;
  buttonDisable?: boolean;
}

const LeaveTypeModal: React.FC<PlaylistTypeModalContentProps> = ({
  handleSubmit,
  leaveType,
  setLeaveType,
  shortCode,
  setShortCode,
  handleClose,
  updateForm,
  buttonDisable,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      {/* First Input */}
      <CustomInput
        label="Leave Type"
        asterisk={true}
        type="text"
        value={leaveType}
        style={{
          backgroundColor: "transparent",
          border: "0.2px solid #d4d4d4",
          flex: 1,
        }}
        // onChange={(e) => handleChange(e, "LeaveFrom")}
        onChange={(e) => {
          const value = e.target.value;
          // Allow only alphabets and spaces
          if (/^[A-Za-z\s]*$/.test(value)) {
            setLeaveType(value);
          }
        }}
      />
      {/* Second Input */}
      <CustomInput
        label="Leave Short Code"
        asterisk={true}
        type="text"
        value={shortCode}
        style={{
          backgroundColor: "transparent",
          border: "0.2px solid #d4d4d4",
          flex: 1,
        }}
        // onChange={(e) => handleChange(e, "LeaveFrom")}
        onChange={(e) => {
          const value = e.target.value;
          if (/^[A-Za-z\s]*$/.test(value)) {
            setShortCode(value);
          }
        }}
      />

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          disabled={buttonDisable}
        >
          {updateForm === "Submit" ? "Submit" : "Update"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default LeaveTypeModal;
